import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/app-content.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Alegreya\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-serif\"}],\"variableName\":\"alegreya\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/workspace/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/workspace/src/context/auth-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/workspace/src/context/theme-context.tsx");
